import momentJalaali from "moment-jalali";
import { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Col, FormGroup, Modal, OverlayTrigger, Popover, Row, Table } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import { referDocument } from "../../store/api/Users";
import Loader from 'react-loader-spinner';
import { ClockHistory, DashCircle, JournalText, Reply, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker2';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faReply } from "@fortawesome/free-solid-svg-icons";
import { getDocumentReferList } from "../../store/api/Users";
import { /*getStageAuthorizedStatusList,*/ getStageUserAndStatusList, getDefaultDescList, getUserList } from "../../Office/store/api/FlowAPI";
import { setErrorDialog } from "../../store/api/CommonFunctions";
const ModalReferDocument = (props) => {
    const dispatch = useDispatch();
    const now = momentJalaali().format("YYYY-MM-DD HH:mm");
    const [referData, setRefData] = useState({ DisplayDate: now, DeadlineDate: now, Priority: 2, SendSMSToStaff: true });
    const selectedIDs = useRef([]);
    const [err, setError] = useState({});
    const [pending, setPending] = useState(false);
    const [defaultDescList, setDefaultDescList] = useState(null);
    const [statusHardCode, setStatusHardCode] = useState(null);
    const [statusAndUserList, setstatusAndUserList] = useState({ Data: [] });
    const [referList, setReferList] = useState(null);
    const { popData, setPopData } = props;
    const { documentHardCode, documentID, show, onRefer, documentNumber, stageID, onStatusChanged, filterOnCurrentUser, workDeadline } = popData;
    const pWorkDeadline = workDeadline ? momentJalaali(workDeadline).format("jYYYY/jMM/jDD") : null;
    const popRefList = (
        <Popover style={{ fontFamily: "Vazir", minWidth: "600px" }}>
            <Popover.Title className="headerStyle">
                <JournalText size={18} />&nbsp;
                تاریخچه ارجاع
            </Popover.Title>
            <Popover.Content>
                <div className="scThin" style={{ maxHeight: "250px", overflow: "auto" }}>
                    <Table className="mb-0 designedTable" style={{ whiteSpace: "noWrap", "--rowColor": "#dfe6ff" }}>
                        <thead>
                            <tr>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>تاریخ ارجاع</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>ارجاع دهنده</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>ارجاع به</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>شرح ارجاع</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>خوانده شده</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>انجام شده</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>رد شده</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#9daae2", zIndex: 50 }}>دلیل رد</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(referList?.Data) &&
                                referList.Data.map((ref, i) =>
                                    <tr key={i}>
                                        <td>{ref.PEnterDate}</td>
                                        <td>{ref.ReferByName}</td>
                                        <td>{ref.UserName}</td>
                                        <td>{ref.ReferDescription}</td>
                                        <td><input type="checkbox" readOnly checked={ref.IsRead} /></td>
                                        <td><input type="checkbox" readOnly checked={ref.IsDone} /></td>
                                        <td><input type="checkbox" readOnly checked={ref.IsRejected} /></td>
                                        <td>{ref.RejectDescription}</td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>
                </div>
            </Popover.Content>
        </Popover>
    )
    function close() {
        selectedIDs.current = [];
        setError({});
        setRefData({ ...referData, DisplayDate: now, DeadlineDate: now, SendSMSToStaff: true });
        setStatusHardCode(null);
        setPopData({ show: false });
        setPending(false);
    };
    function referDoc() {
        setError({
            UserID: !referData.UserID ? 'N' : null,
            Deadline: !referData.DeadlineDate ? 'N' : null,
            Display: !referData.DisplayDate ? 'N' : null,
            Priority: !referData.Priority || referData.Priority === '' ? "N" : null,
            ReferDescription: (!referData.ReferDescription || referData.ReferDescription === '') ? "N" : null
        });
        if (!referData.UserID || !referData.DeadlineDate || !referData.DisplayDate ||
            !referData.Priority || referData.Priority === '' ||
            !referData.ReferDescription || referData.ReferDescription === '') {
            return;
        }
        setPending(true);
        referData.DocumentGroupHardCode = documentHardCode;
        referData.DocumentHardCode = documentHardCode;
        referData.DocumentID = documentID;
        referData.WorkDeadline = workDeadline;
        if (documentHardCode === "install" || documentHardCode === "repair") {
            referData.ReferDescription = referData.ReferDescription;
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ارجاع به کاربر");
                return;
            }
            close();
            setPending(false);
            setErrorDialog(dispatch, "success", "ارجاع به کاربر");
            if (onRefer) {
                onRefer();
            }
            if (onStatusChanged && Number(referData.StatusID) > 0) {
                const stgName = statusAndUserList.Data.StatusList.find(s => Number(s.ID) === Number(referData.StatusID)).StageName;
                onStatusChanged(referData.StatusID, stgName);
            }

        }
        referDocument(referData, onSuccess);
    }
    function onDocStatusChanged(e) {
        referData.DocumentStatusID = e.target.value;
        const hrdCode = statusAndUserList.Data.StatusList.find(s => Number(s.ID) === Number(e.target.value)).HardCode;
        setStatusHardCode(hrdCode);
    }
    useEffect(() => {
        if (show) {
            getDocumentReferList(documentHardCode, null, null, null, setReferList, documentID);
            if (filterOnCurrentUser) {
                const onGet = (res) => {
                    setstatusAndUserList({ Data: { UserList: res } });
                }
                getUserList("", onGet, true);
            }
            else {
                getStageUserAndStatusList("", stageID, setstatusAndUserList);
            }
            getDefaultDescList(setDefaultDescList);
            //getStageAuthorizedStatusList(stageID, setStatusList);
        }
    }, [show])
    return (
        <Modal show={show === true} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faReply} size="lg" />&nbsp;
                    ارجاع به کارتابل کاربر
                </span>
            </Modal.Header>
            <Modal.Body className="bodyStyle" style={{ paddingTop: "2px" }}>
                <Row>
                    {pWorkDeadline ? <div style={{ textAlign: "center", marginTop: "3px" }}>
                        <ClockHistory size={16} color="purple" style={{ display: "inline-block" }} />&nbsp;
                        <label style={{ fontSize: "12px", fontWeight: "bold", color: "blue" }}>مهلت انجام کار: {pWorkDeadline}</label>
                    </div> : null}
                    <FormGroup>
                        {Array.isArray(statusAndUserList?.Data?.UserList) ?
                            <select className="form-control" defaultValue="" onChange={e => referData.UserID = e.target.value}>
                                <option value="">کاربر را انتخاب کنید</option>
                                {
                                    statusAndUserList.Data.UserList.map((st, i) => <option key={i} value={st.ID}>{st.Name}</option>)}
                            </select> :
                            <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={23} height={23} style={{ display: "inline-block" }} />&nbsp; در حال بارگذاری فهرست</div>
                        }
                        {err.UserID && <small className='errors' style={{ fontSize: "9px" }}>انتخاب دست کم یک کاربر الزامی است</small>}
                    </FormGroup>
                    <Col md={6} className="form-group">
                        <label>تاریخ نمایش:</label>
                        <DatePicker isGregorian={false} timePicker={true} className="form-control" inputFormat="YYYY-MM-DD HH:mm"
                            onChange={value => setRefData({ ...referData, DisplayDate: value.local("en").format("YYYY/MM/DD HH:mm") })} value={momentJalaali(referData.DisplayDate)} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                        {err.Display && <small className='errors' style={{ fontSize: "9px" }}>تاریخ نمایش الزامی است</small>}
                    </Col>
                    <Col md={6} className="form-group">
                        <label>تاریخ سررسید:</label>
                        <DatePicker isGregorian={false} timePicker={true} className="form-control" min={momentJalaali()} inputFormat="YYYY-MM-DD HH:mm"
                            onChange={value => setRefData({ ...referData, DeadlineDate: value.local("en").format("YYYY/MM/DD HH:mm") })} value={momentJalaali(referData.DeadlineDate)} inputJalaaliFormat="jYYYY/jMM/jDD HH:mm" />
                        {err.Deadline && <small className='errors' style={{ fontSize: "9px" }}>تاریخ سررسید الزامی است</small>}
                    </Col>
                    <FormGroup className={statusAndUserList?.Data?.StatusList ? 'col-md-6' : ""}>
                        <select className="form-control" onChange={e => referData.Priority = e.target.value} defaultValue={2}>
                            <option value=''>انتخاب اولویت</option>
                            <option value={3}>پایین</option>
                            <option value={2}>معمولی</option>
                            <option value={1}>بالا</option>
                        </select>
                        {err.Priority && <small className='errors' style={{ fontSize: "9px" }}>انتخاب اولویت الزامی است</small>}
                    </FormGroup>
                    <FormGroup className="col-md-6">
                        {Array.isArray(statusAndUserList?.Data?.StatusList) &&
                            <select className="form-control" defaultValue="" onChange={onDocStatusChanged}>
                                <option value="">وضعیت را انتخاب کنید</option>
                                {
                                    statusAndUserList.Data.StatusList.map((st, i) => <option key={i} value={st.ID}>{st.Name}</option>)}
                            </select>
                        }
                    </FormGroup>
                    <FormGroup>
                        <label>شرح پیش فرض ارجاع:</label>
                        {defaultDescList?.Data?.length > 0 ?
                            <select className="form-control" defaultValue="" onChange={e => setRefData({ ...referData, ReferDescription: e.target.value })}>
                                <option value="">انتخاب کنید</option>
                                {defaultDescList?.Data.map((desc, i) => <option key={i} value={desc.InfoName}>{desc.InfoName}</option>)}
                            </select>
                            :
                            <div className="form-control"><Loader type="BallTriangle" color="#bb1370" width={23} height={23} style={{ display: "inline-block" }} />&nbsp; در حال بارگذاری فهرست</div>
                        }
                    </FormGroup>
                    <FormGroup>
                        <input type="text" className='form-control' placeholder="َشرح ارجاع" onChange={e => setRefData({ ...referData, ReferDescription: e.target.value })} value={referData?.ReferDescription ?? ""} />
                        {err.ReferDescription && <small className='errors' style={{ fontSize: "9px" }}>شرح ارجاع الزامی است</small>}
                    </FormGroup>
                    {statusHardCode === "sent" &&
                        <FormGroup style={{ maxWidth: "max-content" }}>
                            <div className="rowBorder" style={{ padding: "8px" }}>
                                <input type='checkbox' className='form-check-input' defaultChecked={false} onChange={e => referData.ShowStaffInfoToCustomer = e.target.checked} />
                                &nbsp;
                                <span style={{ fontSize: "12px", color: "blue" }}>نمایش اطلاعات تماس به مشتری</span>&nbsp;
                                <div style={{ display: "inline-block" }}>
                                    <input type='checkbox' className='form-check-input' defaultChecked={true} onChange={e => referData.SendSMSToStaff = e.target.checked} />
                                    &nbsp;
                                    <span style={{ fontSize: "12px", color: "blue" }}>ارسال پیامک به تکنسین</span>
                                </div>
                            </div>
                        </FormGroup>
                    }
                </Row>
                <Button className="group-Btn mt-1" variant="info" style={{ fontSize: "12px" }} onClick={referDoc} disabled={pending}><Reply size={16} /> ارجاع به کاربر</Button>
                <Button className="group-Btn mt-1" variant="danger" style={{ fontSize: "12px" }} onClick={close}><DashCircle size={16} /> انصراف</Button>
                <OverlayTrigger overlay={popRefList} trigger="click" rootClose placement="left">
                    <Button className="group-Btn mt-1" variant="secondary" style={{ fontSize: "12px" }}><JournalText size={16} />&nbsp;تاریخچه ارجاع</Button>
                </OverlayTrigger>
            </Modal.Body>
        </Modal>
    )
}
export default ModalReferDocument;